export var SIGN_OUT = "client/login/SIGN_OUT";
export default function signOut() {
  return {
    "type": SIGN_OUT
  };
}